// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-wrapper-table-favorite-toggle-cell {
  width: 40px;
  height: 40px;
}
.fi-wrapper-table-favorite-toggle-cell .mat-icon {
  line-height: 24px;
  text-align: center;
  transition: all 0.2s;
}
.fi-wrapper-table-favorite-toggle-cell .mat-icon.favorite {
  color: gold;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-wrapper-table/cells/fi-wrapper-table-favorite-toggle-cell/fi-wrapper-table-favorite-toggle-cell.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;AACJ;AACI;EACI,iBAAA;EACA,kBAAA;EAIA,oBAAA;AAFR;AADQ;EACI,WAAA;AAGZ","sourcesContent":[".fi-wrapper-table-favorite-toggle-cell {\r\n    width: 40px;\r\n    height: 40px;\r\n\r\n    .mat-icon {\r\n        line-height: 24px;\r\n        text-align: center;\r\n        &.favorite {\r\n            color: gold;\r\n        }\r\n        transition: all 0.2s;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
